// 메뉴 API
import axiosInstance from './axiosInstance';

export const getMyMenus = () =>
  axiosInstance.get('/menu/my-menus').then(r => r.data);

export const getAllMenus = () =>
  axiosInstance.get('/menu/all-menus').then(r => r.data);

export const getManageMenus = () =>
  axiosInstance.get('/menu/manage').then(r => r.data);

export const createMenu = (body) =>
  axiosInstance.post('/menu', body).then(r => r.data);

export const updateMenu = (menuId, body) =>
  axiosInstance.put(`/menu/${menuId}`, body).then(r => r.data);

export const deleteMenu = (menuId) =>
  axiosInstance.delete(`/menu/${menuId}`).then(r => r.data);
